import CoreDocumentTypeDialog from "./CoreDocumentTypeDialog";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const uiSchema = {
  "attributes": {
      "ui:options": {
          orderable: false
      }
  }
};

const CoreDocumentTypePropertiesPanel = ({formId, documentTypeSchemaRequired, documentTypeSchemaOptional, saveDocumentTypeData, formData, readOnly, handleFormChange }) => {
    return (
        <div>
            <Typography style={{fontWeight: 'bold'}}>Required Fields</Typography>
            <CoreDocumentTypeDialog formId={formId} documentTypeSchema={documentTypeSchemaRequired}
              uiSchema={uiSchema} saveDocumentTypeData={saveDocumentTypeData} formData={formData}
              handleFormChange={handleFormChange} readOnly={readOnly}/>
              <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
              <Typography style={{fontWeight: 'bold'}}>Optional Fields</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  <CoreDocumentTypeDialog formId={formId} documentTypeSchema={documentTypeSchemaOptional}
                    uiSchema={uiSchema} saveDocumentTypeData={saveDocumentTypeData} formData={formData}
                    handleFormChange={handleFormChange} readOnly={readOnly}/>
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>

    );
}

export default CoreDocumentTypePropertiesPanel;